import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient";
import { IDashboard } from "./types/_dashboard";
const api = new APIClient();

const path = "/trade";
const tradeApi = {
  dashboard(params: any): Promise<AxiosResponse<IDashboard, any>> {
    const url = `${path}/summaries`;
    return api.get(url, params);
  },
};
export default tradeApi;
